/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Uppercase {
  /**
   * Uppercase all letters
   *
   * @public
   * @function f1.uppercase
   * @param s any string
   * @example
   *
   * ```ts
   * f1.uppercase('Hi how') === 'HI HOW'
   * ```
   */
  (s: string): string;
}

/**
 * @see Uppercase
 */
export default (s: string) => {
  return s.toUpperCase();
};
